document.querySelectorAll("table:not([data-ignore-table])").forEach(function(table) {
    const headers = [];

    const hasThead = table.querySelector('thead');

    if (hasThead) {
        // Get all headers from the thead
        table.querySelectorAll('thead tr th').forEach(function(th) {
            headers.push(th.innerText);
        });
    } else {
        // Check if the first row in tbody has th elements
        const firstRow = table.querySelector('tbody tr:first-child');
        
        // If first row contains only th, it's assumed to be wrongly set by the author
        if (firstRow && !firstRow.querySelector('td')) {
            firstRow.querySelectorAll('th').forEach(function(th) {
                headers.push(th.innerText);
            });

            firstRow.classList.add('desktop-only');
        }
    }

    if (headers.length > 0 ){
       table.classList.add('responsive-table');
    }

    // Set data label for each row's cells
    table.querySelectorAll('tbody tr').forEach(function(row) {
        row.querySelectorAll('td').forEach(function(cell, index) {
            cell.setAttribute('data-label', headers[index]);
        });
    });
});